import { z } from "zod";

// Cost breakdown schemas
export const CostBreakdownItemSchema = z.object({
  name: z.string(),
  total_dbus: z.number(),
  estimated_cost: z.number(),
  pct_of_total: z.number(),
  record_count: z.number().nullable().optional(),
});

export const CostBreakdownResponseSchema = z.object({
  breakdown: z.array(CostBreakdownItemSchema),
  group_by: z.string(),
  total_dbus: z.number(),
  total_cost: z.number(),
});

export type CostBreakdownItem = z.infer<typeof CostBreakdownItemSchema>;
export type CostBreakdownResponse = z.infer<typeof CostBreakdownResponseSchema>;

// Workspace schemas
export const WorkspaceSchema = z.object({
  workspace_id: z.string(),
  workspace_name: z.string().nullable().optional(),
});

export const WorkspacesResponseSchema = z.object({
  workspaces: z.array(WorkspaceSchema),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;
export type WorkspacesResponse = z.infer<typeof WorkspacesResponseSchema>;

// Cost total schema
export const CostTotalResponseSchema = z.object({
  total_cost: z.number().nullable(),
  total_dbus: z.number().nullable(),
});

export type CostTotalResponse = z.infer<typeof CostTotalResponseSchema>;

// Product trends schemas
export const ProductTrendItemSchema = z.object({
  period: z.string(),
  product: z.string(),
  total_dbus: z.number(),
  estimated_cost: z.number(),
});

export const ProductTrendsResponseSchema = z.object({
  trends: z.array(ProductTrendItemSchema),
  granularity: z.string(),
});

export type ProductTrendItem = z.infer<typeof ProductTrendItemSchema>;
export type ProductTrendsResponse = z.infer<typeof ProductTrendsResponseSchema>;

// Workspace efficiency schemas
export const WorkspaceEfficiencyItemSchema = z.object({
  workspace_id: z.string(),
  workspace_name: z.string().nullable().optional(),
  estimated_cost: z.number(),
  jobs_pct: z.number(),
  all_purpose_pct: z.number(),
  serverless_pct: z.number(),
  efficiency_score: z.string(),
});

export const WorkspaceEfficiencyResponseSchema = z.object({
  workspaces: z.array(WorkspaceEfficiencyItemSchema),
});

export type WorkspaceEfficiencyItem = z.infer<typeof WorkspaceEfficiencyItemSchema>;
export type WorkspaceEfficiencyResponse = z.infer<typeof WorkspaceEfficiencyResponseSchema>;

// API params interfaces
export interface WorkspacesCostParams {
  start_date: string;
  end_date: string;
  workspace_id?: string;
}

export interface WorkspacesTrendsParams extends WorkspacesCostParams {
  granularity?: "day" | "month";
}

export interface WorkspacesBreakdownParams extends WorkspacesCostParams {
  group_by?: "workspace" | "sku" | "product";
}
